var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0.625C5.95571 0.625 4.95419 1.03984 4.21577 1.77827C3.47734 2.51669 3.0625 3.51821 3.0625 4.5625V6.8125C2.46576 6.8125 1.89347 7.04955 1.47151 7.47151C1.04955 7.89347 0.8125 8.46576 0.8125 9.0625V14.125C0.8125 14.7217 1.04955 15.294 1.47151 15.716C1.89347 16.1379 2.46576 16.375 3.0625 16.375H10.9375C11.5342 16.375 12.1065 16.1379 12.5285 15.716C12.9504 15.294 13.1875 14.7217 13.1875 14.125V9.0625C13.1875 8.46576 12.9504 7.89347 12.5285 7.47151C12.1065 7.04955 11.5342 6.8125 10.9375 6.8125V4.5625C10.9375 2.3875 9.175 0.625 7 0.625ZM9.8125 6.8125V4.5625C9.8125 3.81658 9.51618 3.10121 8.98874 2.57376C8.46129 2.04632 7.74592 1.75 7 1.75C6.25408 1.75 5.53871 2.04632 5.01126 2.57376C4.48382 3.10121 4.1875 3.81658 4.1875 4.5625V6.8125H9.8125Z",
    fill: "#CC0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.53416c84fcd88ebf8555656d5597429f.svg";
export { ForwardRef as ReactComponent };